import { regularUnstoppableDomain } from '@cryptoboyio/mercuryo-lab/utils';
import { createReducer } from '@reduxjs/toolkit';

import { loadersBuilder, errorBuilder, logoutBuilder } from '@modules/builders';

import withdrawActions from './actions';
import initialState from './state';
import type * as WithdrawTypes from './types';

export const withdrawReducer = createReducer(initialState, builder => {
  builder.addCase(withdrawActions.setAddress, (state, action) => {
    const { address, currency } = action.payload;
    if (state.errors.data?.address) state.errors.data.address = '';
    if (address) state.addressLoading = true;
    const domain = regularUnstoppableDomain.test(address) ? address : '';

    state.address = {
      ...state.address,
      [currency]: {
        domain,
        address,
        isValid: false,
        currency,
      },
    };
  });

  builder.addCase(withdrawActions.setAddressValidation, (state, action) => {
    const { currency } = action.payload;
    if (currency) {
      state.address = {
        ...state.address,
        [currency]: {
          ...state.address[currency],
          ...action.payload,
        },
      };
    }
  });

  builder.addCase(withdrawActions.setAddressLoading, (state, action) => {
    state.addressLoading = action.payload;
  });

  builder.addCase(withdrawActions.clearAddressData, state => {
    state.address = {};
    delete state.addressLoading;
  });

  builder.addCase(withdrawActions.setFeeId, (state, action) => {
    state.feeId = action.payload;
  });

  builder.addCase(withdrawActions.clearErrors, state => {
    state.errors = {};
  });

  loadersBuilder('withdraw', builder);
  logoutBuilder(initialState, builder);
  errorBuilder('withdraw', builder);
});

export { withdrawActions, WithdrawTypes };
